import { apiInterfaceForJson } from '../common/apiManager';

export const getAllLabHubLists = () =>
    apiInterfaceForJson('/labHub/v1/lists', 'GET', null);

export const getLabHubList = (listName) =>
    apiInterfaceForJson(`/labHub/v1/${listName}`, 'GET', null);

export const addLabHubItem = (listName, item) =>
    apiInterfaceForJson(`/labHub/v1/${listName}/items`, 'POST', item);

export const updateLabHubItem = (listName, itemId, fields) =>
    apiInterfaceForJson(`/labHub/v1/${listName}/items/${itemId}`, 'PATCH', fields);

export const deleteLabHubItem = (listName, itemId) =>
    apiInterfaceForJson(`/labHub/v1/${listName}/items/${itemId}`, 'DELETE', null);

export const reorderLabHubItems = (listName, orderedIds) =>
    apiInterfaceForJson(`/labHub/v1/${listName}/reorder`, 'POST', { orderedIds });
